<mat-card class="digital-contract">
  <app-fill-labor-contract-report-moha *ngIf="showInfo"></app-fill-labor-contract-report-moha>
  <mat-card-content class="mat-card-content-contract-sm w-100 bg-white" *ngIf="!showInfo">
    <mat-accordion #accordion="matAccordion" [multi]="true" class="row w-100">
      <div [hidden]="isViewFull" class="col-5 digital-contract_infor">
        <mat-expansion-panel class="mat-elevation-z "
                             expanded="true"
                             #mePanel="matExpansionPanel"
        >
          <mat-expansion-panel-header>
            <!-- Thông tin liên hệ -->
            <mat-panel-title class="mat-panel-title justify-content-between">
               <span *ngIf="mode !== 'view'">
              {{ 'form.digital_contract.document_information' | translate }}
            </span>
              <span *ngIf="mode === 'view'" class="content-view">
                {{ 'breadcrumbs.document_digitization_view_moha' | translate }} {{ mainFormAdd.controls.docName.value }}
            </span>
              <small *ngIf="mode !== 'view'" class="form-text text-gray pull-left">(<span
                style="color: red;">*</span>) {{
                  'form.info' |
                    translate
                }}
              </small>
            </mat-panel-title>
          </mat-expansion-panel-header>

          <div *ngIf="mode !== 'view'">
            <form [formGroup]="mainFormAdd" class="py-3">
              <!--Loại hợp đồng-->
              <mat-form-field class="w-100">
                <mat-label>{{ 'form.digital_contract.document_type' | translate }}</mat-label>
                <mat-select #serviceTypeSelect (focus)="commonService.openComboBox(checkFocus, serviceTypeSelect)"
                            (focusout)="(checkFocus = true)"
                            (selectionChange)="checkFocus = false; selectedChange($event)"
                            formControlName="docType" required>
                  <mat-option>
                    <ngx-mat-select-search [formControl]="serviceTypeCtrl"
                                           [noEntriesFoundLabel]="'autocomplete.suggestion' | translate"
                                           [placeholderLabel]="'search_form.search' | translate">
                    </ngx-mat-select-search>
                  </mat-option>
                  <mat-option (click)="this.commonService.closeDropdownList(this.serviceTypeSelect)"
                              *ngFor="let serviceType of filteredServiceTypes | async"
                              [value]="serviceType.id">
                    {{ serviceType.name }}
                  </mat-option>
                </mat-select>
                <button (click)="mainFormAdd.controls.docType.reset(''); mainFormAdd.controls.docContractType.reset('')"
                        *ngIf="mainFormAdd.controls.docType.value && mode !== 'view' && !mainFormAdd.controls.docParent.value"
                        aria-label="Clear" mat-button
                        mat-icon-button matSuffix type="button">
                  <mat-icon>close</mat-icon>
                </button>
                <mat-error *ngIf="mainFormAdd.controls.docType.hasError('required')">
                  {{ 'digital_contract.error.service_type_required' | translate }}
                </mat-error>
              </mat-form-field>


              <!-- Loại hợp đồng lao động -->
              <mat-form-field class="w-100">
                  <mat-label>{{'form.digital_contract.labor_contract_type' | translate}}</mat-label>
                  <input matInput [value]="mainFormAdd.controls['docContractType'].value | translate" disabled>
              </mat-form-field>

              <!--  tên hợp đồng-->
              <mat-form-field class="w-100">
                <input (focusout)="focusOut('docName')"
                       [placeholder]="'form.digital_contract.document_name' | translate" formControlName="docName"
                       matInput
                       maxlength="100" required
                       type="text">
                <button (click)="reset('docName')" *ngIf="mainFormAdd.controls.docName.value && mode !== 'view'"
                        aria-label="Clear" mat-button
                        mat-icon-button matSuffix type="button">
                  <mat-icon>close</mat-icon>
                </button>

                <mat-error *ngIf="mainFormAdd.controls.docName.hasError('required')">
                  {{ 'digital_contract.error.contract_name_required' | translate }}
                </mat-error>
              </mat-form-field>

              <!--  mã hợp đồng-->
              <mat-form-field class="w-100">
                <input (focusout)="focusOut('docCode')"
                       [placeholder]="'form.digital_contract.document_code' | translate" formControlName="docCode"
                       matInput
                       maxlength="50" required
                       type="text">
                <button (click)="reset('docCode')" *ngIf="mainFormAdd.controls.docCode.value && mode !== 'view'"
                        aria-label="Clear" mat-button
                        mat-icon-button matSuffix type="button">
                  <mat-icon>close</mat-icon>
                </button>
                <mat-error *ngIf="mainFormAdd.controls.docCode.hasError('required')">
                  {{ 'digital_contract.error.contract_code_required' | translate }}
                </mat-error>
                <mat-error *ngIf="mainFormAdd.controls.docCode.hasError('pattern')">
                  {{ "digital_contract.error.contract_code_pattern" | translate }}
                </mat-error>
                <mat-error *ngIf="mainFormAdd.controls.docCode.hasError('matched')">
                  {{ "validation.document_code_duplicate" | translate }}
                </mat-error>
              </mat-form-field>

              <!--      Ngày hiệu lực từ ngày đến ngày-->
              <mat-form-field class="w-100">
                <input (change)="someMethod($event.target)" (focusout)="dateFocusOut('effectiveDate')"
                       (input)="someMethod($event.target); dateField = 'effectiveDate'"
                       [matDatepicker]="dp3"
                       [max]="mainFormAdd.controls.expirationDate.value"
                       [placeholder]="'form.digital_contract.effective_date' | translate"
                       formControlName="effectiveDate"
                       matInput
                       required>
                <mat-datepicker-toggle [for]="dp3" matSuffix>

                </mat-datepicker-toggle>
                <mat-datepicker #dp3></mat-datepicker>
                <mat-error
                  *ngIf="mainFormAdd.controls.effectiveDate.hasError('required') && !mainFormAdd.controls.effectiveDate.hasError('matDatepickerParse')">
                  {{ 'digital_contract.error.effective_time_required' | translate }}
                </mat-error>
                <mat-error
                  *ngIf="mainFormAdd.controls.effectiveDate.hasError('matDatepickerMax') && dateField === 'effectiveDate'">
                  {{ "digital_contract.error.effectiveDate_validate" | translate }}
                </mat-error>
                <mat-error *ngIf="mainFormAdd.controls.effectiveDate.hasError('matDatepickerParse')">
                  {{ "digital_contract.error.date_pattern" | translate }}
                </mat-error>
              </mat-form-field>

              <mat-form-field class="w-100">
                <input (focusout)="dateFocusOut('expirationDate')" (input)="dateField = 'expirationDate'"
                       [matDatepicker]="dp4"
                       [min]="mainFormAdd.controls.effectiveDate.value"
                       [placeholder]="'form.digital_contract.expiration_date' | translate"
                       formControlName="expirationDate"
                       matInput
                       [required]="hasRequiredValidator('expirationDate')"
                       >
                <mat-datepicker-toggle [for]="dp4" matSuffix>

                </mat-datepicker-toggle>
                <mat-datepicker #dp4></mat-datepicker>
                <mat-error
                  *ngIf="mainFormAdd.controls.expirationDate.hasError('matDatepickerMin') && dateField === 'expirationDate'">
                  {{ "digital_contract.error.expiredDate_validate" | translate }}
                </mat-error>
                <mat-error *ngIf="mainFormAdd.controls.expirationDate.hasError('matDatepickerParse')">
                  {{ "digital_contract.error.date_pattern" | translate }}
                </mat-error>
                <mat-error *ngIf="mainFormAdd.controls.expirationDate.hasError('required')">
                  {{ "digital_contract.error.expiredDate_required" | translate }}
                </mat-error>

              </mat-form-field>

              <!--  Mô tả-->
              <mat-form-field class="w-100">
                <input (focusout)="focusOut('description')"
                       [placeholder]="'form.digital_contract.description' | translate" formControlName="description"
                       matInput maxlength="200"
                       type="text">
                <button (click)="mainFormAdd.controls.description.reset('')"
                        *ngIf="mainFormAdd.controls.description.value" aria-label="Clear" mat-button
                        mat-icon-button matSuffix type="button">
                  <mat-icon>close</mat-icon>
                </button>
              </mat-form-field>
              <!-- Cho phép khách hàng xem nội dung -->
              <div class="w-100">
                <mat-checkbox  formControlName="allowReferenceCustomerView" color="primary"><strong>{{'form.digital_contract.allow_reference_customer_view' | translate}}</strong></mat-checkbox>
              </div>
            </form>
          </div>

          <!-- Thêm bên lập -->
          <!-- <div class="row p-table-base border-top-right-left font-color-blue" style="font-weight: 600; align-items: center;" *ngIf="!enterpriseSign.length">
            {{ "form.add_create_sign" | translate }}
            <mat-icon class="ml-0 text-primary" style="font-size: x-large; cursor: pointer; margin-left: 8px !important;"
                      matTooltip="{{ 'form.add_create_sign' | translate }}" (click)="addEnterprise(true)">
              add_circle_outline
            </mat-icon>
          </div> -->

          <!-- View contract -->
          <div *ngIf="mode === 'view'" class="mt-3">
            <!-- Mã hợp đồng -->
            <div class="row my-4">
              <label class="col-lg-5 col-md-6">
                {{ 'form.digital_contract.document_code' | translate }}
              </label>
              <div class="col-lg-7 col-md-6 content-view">
                <b>{{ mainFormAdd.controls.docCode.value }}</b>
              </div>
            </div>

            <!-- Tên hợp đồng -->
            <div class="row my-4">
              <label class="col-lg-5 col-md-6">
                {{ 'form.digital_contract.document_name' | translate }}
              </label>
              <div class="col-lg-7 col-md-6 content-view">
                <b>{{ mainFormAdd.controls.docName.value }}</b>
              </div>
            </div>

            <!-- Loại hợp đồng -->
            <div class="row my-4">
              <label class="col-lg-5 col-md-6">
                {{ 'form.digital_contract.document_type' | translate }}
              </label>
              <div class="col-lg-7 col-md-6 content-view">
                <b>{{ mainFormAdd.controls.docType.value }}</b>
              </div>
            </div>
            <!-- Trạng thái -->
            <div class="row my-4">
              <label class="col-lg-5 col-md-6">
                {{ 'search_form.status' | translate }}
              </label>
              <div class="col-lg-7 col-md-6 content-view">
                <nz-tag *ngIf="contractStatus == 1">{{ 'search_form.draft' | translate }}</nz-tag>
                <nz-tag *ngIf="contractStatus == 2" [nzColor]="'blue'">{{ 'search_form.processing' | translate }}</nz-tag>
                <nz-tag *ngIf="contractStatus == 3" [nzColor]="'red'">{{ 'search_form.denied_sign' | translate }}</nz-tag>
                <nz-tag *ngIf="contractStatus == 5" [nzColor]="'red'">{{ 'search_form.cancelled' | translate }}</nz-tag>
                <nz-tag *ngIf="contractStatus == 7" [nzColor]="'red'">{{ 'search_form.cancelled' | translate }}</nz-tag>
                <nz-tag *ngIf="contractStatus == 8" [nzColor]="'green'">{{ 'contract_share_partner.issued' | translate }}</nz-tag>
              </div>
            </div>

            <!-- Ngày hiệu lực -->
            <div class="row my-4">
              <label class="col-lg-5 col-md-6">
                {{ 'form.digital_contract.effective_date' | translate }}
              </label>
              <div class="col-lg-7 col-md-6 content-view">
                <b>{{ mainFormAdd.controls.effectiveDate.value | date:'dd/MM/yyyy' }}</b>
              </div>
            </div>

            <!-- Ngày hết hiệu lực -->
            <div class="row my-4">
              <label class="col-lg-5 col-md-6">
                {{ 'form.digital_contract.expiration_date' | translate }}
              </label>
              <div class="col-lg-7 col-md-6 content-view">
                <b>{{ mainFormAdd.controls.expirationDate.value | date:'dd/MM/yyyy' }}</b>
              </div>
            </div>

            <!-- Trạng thái chứng thực -->
              <div class="row my-4">
                <label class="col-lg-5 col-md-6">
                  {{ 'headertable.status_sign' | translate }}
               </label>
               <div class="col-lg-7 col-md-6 content-view">
                 <nz-tag *ngIf="mohaConfirmStatus == 1">{{ 'contract_terminate.no_sign' | translate }}</nz-tag>
                  <nz-tag *ngIf="mohaConfirmStatus == 2 || mohaConfirmStatus == 4" [nzColor]="'blue'">{{ 'contract_terminate.signing' | translate }}</nz-tag>
                 <nz-tag *ngIf="mohaConfirmStatus == 3" [nzColor]="'red'">{{ 'contract_terminate.failed' | translate }}</nz-tag>
                 <nz-tag *ngIf="mohaConfirmStatus == 5" [nzColor]="'red'">{{ 'search_form.cancelled' | translate }}</nz-tag>
                 <nz-tag *ngIf="mohaConfirmStatus == 6" [nzColor]="'green'">{{ 'contract_terminate.signed' | translate }}</nz-tag>
                
                 <!-- Icon tải file tổng hợp bằng chứng: chỉ hiện với người lập hợp đồng/văn bản -->
                 <span *ngIf="isContractCreator && mohaConfirmStatus == 6"
                       class="mat-button-wrapper"
                        matTooltip="{{ 'contract_terminate.download_evident' | translate }}"
                       style="cursor: pointer;"
                        (click)="downloadEvidentFile(contractId)">
                    <mat-icon class="mat-icon notranslate material-icons mat-icon-no-color"
                              role="img"
                              style="color: #07736C;"
                              aria-hidden="true">
                      save_alt
                    </mat-icon>
                  </span>
               </div>
               <div></div>
              </div>
            <!-- Trạng thái gửi lên Nền tảng HDLD-->
            <div class="row my-4">
              <label class="col-lg-5 col-md-6">
                {{ 'headertable.status_send' | translate }}
              </label>
              <div class="col-lg-7 col-md-6 content-view">
                <nz-tag *ngIf="mohaStatus == 1">{{ 'contract_terminate.no_send' | translate }}</nz-tag>
                <nz-tag *ngIf="mohaStatus == 2" [nzColor]="'blue'">{{ 'contract_terminate.sending' | translate }}</nz-tag>
                <nz-tag *ngIf="mohaStatus == 3" [nzColor]="'red'">{{ 'contract_terminate.failed' | translate }}</nz-tag>
                <nz-tag *ngIf="mohaStatus == 4" [nzColor]="'green'">{{ 'contract_terminate.sent' | translate }}</nz-tag>
              </div>
            </div>

            <!--Lý do -->
            <div class="row my-4" *ngIf="contractMohaErrorDescription.length > 0">
              <label class="col-lg-5 col-md-6">
                {{'header.reason' | translate}}
              </label>
              <div class="col-lg-7 col-md-6 content-view">
                <b>{{ contractMohaErrorDescription }}</b>
              </div>
            </div>

            <!--Mã chứng thực-->
            <div class="row my-4" *ngIf="messageAuthenCode != ''">
              <label class="col-lg-5 col-md-6">
                {{'headertable.code_sign' | translate}}
              </label>
              <div class="col-lg-7 col-md-6 content-view">
                <b>{{ messageAuthenCode }}</b>
              </div>
            </div>

            <!--Thời gian chứng thực-->
            <div class="row my-4" *ngIf="messageAuthenDate != ''">
              <label class="col-lg-5 col-md-6">
                {{ 'headertable.time_sign' | translate }}
              </label>
              <div class="col-lg-7 col-md-6 content-view">
                <b>{{ messageAuthenDate | date:'dd/MM/yyyy' }}</b>
              </div>
            </div>

            <!-- UUID Hợp đồng -->
            <div class="row my-4" *ngIf="idMoha">
              <label class="col-lg-5 col-md-6">
                {{ 'headertable.uuid_contract' | translate }}
              </label>
              <div class="col-lg-7 col-md-6 content-view">
                <b>{{ idMoha }}</b>
              </div>
            </div>

            <!-- Mô tả -->
            <div class="row my-4" *ngIf="mainFormAdd.controls.description.value">
              <label class="col-lg-5 col-md-6">
                {{ 'form.digital_contract.description' | translate }}
              </label>
              <div class="col-lg-7 col-md-6 content-view">
                <b>{{ mainFormAdd.controls.description.value }}</b>
              </div>
            </div>
            <div class="row my-4">
              <div class="col-12">
                <mat-checkbox [disabled]="true" [(ngModel)]="mainFormAdd?.getRawValue().allowReferenceCustomerView" [ngModelOptions]="{ standalone: true }" color="primary"><div style="font-weight: 600; color: #000;">{{'form.digital_contract.allow_reference_customer_view' | translate}}</div></mat-checkbox>
              </div>
            </div>
          </div>
        </mat-expansion-panel>

        <!-- Các khách hàng ký kết hợp đồng khi thêm mới cập nhật -->
        <mat-expansion-panel class="mat-elevation-z mt-3"
                             expanded="true"
                             #mePanel="matExpansionPanel" *ngIf="mode !== 'view'"
        >
          <mat-expansion-panel-header *ngIf="mode !== 'view'">
            <!-- Thông tin liên hệ -->
            <mat-panel-title class="mat-panel-title justify-content-between">
              <span>{{ 'form.digital_contract.customer_parent' | translate }}</span>
            </mat-panel-title>
          </mat-expansion-panel-header>

          <div *ngIf="mode !== 'view'">
            <form [formGroup]="mainFormAdd" class="py-3">
              <!--  Hợp đồng cha-->
              <div class="w-100 ">
                <form nz-frm>
                  <nz-table #editRowInternalTable nzBordered [nzData]="RECORD_PARTY_SIGN" [nzShowPagination]="false" [nzNoResult]="contentEmptyTable1"
                            [nzFrontPagination]="false" class="ant-table-no-placeholder-border-bottom">
                    <thead>
                    <tr>
                      <th class="text-center" nzWidth="25px">
                        {{
                          "enterprise_contract.panel_document.table_users.header.order"
                            | translate
                        }}
                      </th>
                      <th class="text-center" nzWidth="80%">
                        {{
                          "form.tbl_kyket"
                            | translate
                        }}
                      </th>
                      <th class="text-center">
                      </th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr *ngFor="let data of editRowInternalTable.data; let i = index" class="editable-row">
                      <!-- TT -->
                      <td class="text-center">{{ i + 1 }}</td>
                      <!-- Tên -->
                      <td class="word-break-line">
                        <div class="editable-cell">
                          <div class="row-icon"> {{ data.name }}
                            <span *ngIf="data.email">- {{ data.email }}</span>
                          </div>
                        </div>
                      </td>
                      <!-- Action -->
                      <td class="td-nz-icon text-center">
                        <a nz-popconfirm [nzIcon]="iconDel" nzPopconfirmTitle="{{
                  'popup.confirm_delete_user' | translate
                }}" (nzOnConfirm)="onClickDeleteElementRecordInternalUserNew(data.customerId)"
                           nzCancelText="{{ 'button.cancel' | translate }}" nzOkText="{{ 'button.ok' | translate }}">
                          <!-- <i class="nz-icon-font" nz-icon nzType="close-square" nzTheme="outline" nz-tooltip
               nzTitle="{{ 'tooltips.delete' | translate }}"></i> -->
                          <i class="fa fa-trash" aria-hidden="true" matTooltip="{{ 'tooltips.delete' | translate }}"></i>
                        </a>
                        <ng-template #iconDel>
                          <i class="text-primary" nz-icon nzType="warning" nzTheme="outline"></i>
                        </ng-template>
                      </td>
                    </tr>
                    <tr class="editable-row" *ngIf="RECORD_PARTY_SIGN.length === 0">
                      <!-- TT -->
                      <td class="text-center">&nbsp;</td>
                      <!-- Tên -->
                      <td colspan="2">
                        <div>
                          <nz-input-group [nzSuffix]="suffixPartyInput">
                            <input nz-input [(ngModel)]="inputPartyValue" (input)="onChangePartySignSearch($event)"
                                   [nzAutocomplete]="autoPartySearching" [ngModelOptions]="{ standalone: true }" placeholder="{{
                        'placeholder.input_paperNumber' | translate
                      }}" #focusPartyInput id="inputParty" />
                            <nz-autocomplete #autoPartySearching>
                              <nz-auto-option *ngFor="let party of filteredPartyOptions" (selectionChange)="
                          autocompletePartySelected($event, party)
                        " [nzValue]="''">
                                <div class="d-flex">
                                  <mat-icon class="mr-2">account_circle</mat-icon>
                                  <span style="line-height: 20px">
                          {{ party.name }} -
                                    {{
                                      party.taxCode && party.taxCode.length > 0
                                        ? party.taxCode
                                        : party.certificateNo
                                    }}
                        </span>
                                </div>
                                <div class="d-flex">
                                  <mat-icon class="mr-2">contact_mail</mat-icon>
                                  <span style="line-height: 20px">
                          <span *ngIf="party.email">{{ party.email }} -</span>
                                    {{ party.phone }}
                        </span>
                                </div>
                                <hr style="margin: 0; padding: 0" />
                              </nz-auto-option>
                            </nz-autocomplete>
                          </nz-input-group>
                          <!-- <mat-error *ngIf="hasCustomerType">
                            {{ "digital_contract.error.expiredDate_required" | translate }}
                          </mat-error> -->
                          <ng-template #suffixPartyInput>
                            <i class="nz-icon-font" nz-icon nz-tooltip nzTitle="{{
                        'enterprise_contract.tooltips.icon_add_new_customer'
                          | translate
                      }}" nzType="plus-circle" nzTheme="outline" (click)="openAddCustomer()"
                               *ngIf="!nzCheckLoadingParty && !isFromSSO && checkDisplayBtnAddCustomer()">
                            </i>
                            <nz-spin *ngIf="nzCheckLoadingParty" nzSimple [nzIndicator]="indicatorPartyInput"></nz-spin>
                          </ng-template>
                          <ng-template #indicatorPartyInput><i class="nz-icon-font" nz-icon nzType="loading"
                                                               style="font-size: 24px"></i>
                          </ng-template>
                        </div>
                      </td>
                      <!-- Thực hiện -->
                      <!--                      <td class="td-nz-icon text-center">&nbsp;</td>-->
                    </tr>
                    </tbody>
                  </nz-table>
                  <ng-template #contentEmptyTable1 ></ng-template>
                </form>
              </div>
            </form>
          </div>

        </mat-expansion-panel>

        <hr *ngIf="mode === 'view'" class="section-divider" />
          <!-- Các khách hàng ký kết hợp đồng khi xem chi tiet -->
          <mat-expansion-panel class="mat-elevation-z mt-3"
                             expanded="true"
                             #mePanel="matExpansionPanel" *ngIf="(mode === 'view' && RECORD_PARTY_SIGN && RECORD_PARTY_SIGN.length > 0)"
        >
        
          <mat-expansion-panel-header *ngIf="mode === 'view'">
            <!-- Thông tin liên hệ -->
            <mat-panel-title class="mat-panel-title justify-content-between">
              <span>{{ 'form.digital_contract.customer_parent' | translate }}</span>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <!-- View contract -->
          <div *ngIf="mode === 'view'" class="mt-3">
            <nz-table #expandTableApprover [nzData]="RECORD_PARTY_SIGN" [nzFrontPagination]="false" [nzShowPagination]="false" [nzNoResult]="contentEmptyTable"
                      class="ant-table-no-placeholder-border-bottom" nzBordered>
              <thead>
              <tr>
                <th class="text-center" nzWidth="40px">
                  {{"approved.no" | translate }}
                </th>
                <th>
                  {{
                    "form.tbl_kyket"
                      | translate
                  }}
                </th>
                <th nzWidth="25px"></th>
              </tr>
              </thead>
              <tbody>
              <ng-container *ngFor="let data of expandTableApprover.data, index as i">
                <tr>
                  <td class="text-center">{{i+1}}</td>
                  <td class="font-weight-bold">{{data.name}}</td>
                  <td nzShowExpand [(nzExpand)]="mapOfExpandData[data.customerId]"></td>
                </tr>
                <tr [nzExpand]="mapOfExpandData[data.customerId]">
                  <td>&nbsp;</td>
                  <td class="td-detail-data" >
                    <span>{{'headertable.customer_code' | translate}}: {{data.customerCode}}<br /></span>
                    <span>{{'form.gpkd' | translate}} : {{data.certificateNo}}<br /></span>
                    <span>{{'footer.contact' | translate}}: <span *ngIf="data.email">{{data.email}}&nbsp;-&nbsp;</span>{{data.phone}} <br /></span>
                  </td>
                  <td>&nbsp;</td>
                </tr>
              </ng-container>
              </tbody>
            </nz-table>
            <ng-template #contentEmptyTable ></ng-template>
          </div>
          </mat-expansion-panel>

        <!-- Luồng ký duyệt nội bộ -->
        <div class="sign_form" *ngIf="mode !== 'view'" style="padding-left: 10px;">
          <div class="note2">
            <div class="note-title">
                {{ "form.note_sign" | translate }}
            </div>

            <div class="note-item">
                {{ "form.note_sign_2" | translate }}
            </div>

            <div class="note-item">
                {{ "form.note_sign_4" | translate }}
            </div>
        </div>

          <div class="row" style="padding-right: 10px !important; padding-left: 10px;">
            <div class="col-12 p-0" style="border-bottom: 1px solid #d9d9d9;">
              <!-- Thêm luồng ký nôi bộ  -->
              <div class="col-12 p-table-base border-top-right-left" style="padding: 0px 0px 10px 0px; border: none;">
                <div class="font-color-blue" style="display: flex; font-weight: 600;">
                  {{ "form.order_of_approval_signing_contract_unit" | translate }} &nbsp;
                  <div class="d-flex">
                    <mat-icon class="mr-0 text-primary" style=" font-size: x-large; cursor: pointer"
                              matTooltip="{{ 'procedure.choose_procedure_private' | translate }}"
                              (click)="openDialogProcedure(2, $event)">add_circle_outline
                    </mat-icon>
                  </div>
                </div>
              </div>
              <!-- Danh sách phê duyệt  -->
              <div class="col-12 row" style="padding: 0; margin: 0; background: #fafafa;">
                <div class="head-table border-top-left" style="width: 20%; max-width: 80px; padding: 10px; color: #ee0033; display: flex; justify-content: center;">
                  {{
                    "enterprise_contract.panel_document.table_users.header.STT"
                      | translate
                  }}
                </div>
                <div class="head-table border-top-left" style="flex: 1; padding: 10px; color: #ee0033;  display: flex; justify-content: center;">
                  {{
                    "enterprise_contract.panel_document.table_users.header.name"
                      | translate
                  }}
                </div>
                <div class="head-table border-top-right-left" style=" width: 20%; padding: 10px;">
                </div>
              </div>
              <div style="display: flex;">
                <div class="p-table-base font-color-blue border-top-right-left" style="width: 60%;padding: 10px; display: flex; align-items: center;">
                  {{ "form.contract_approver" | translate}} &nbsp;
                </div>
                <div class="p-table-base font-color-blue border-top-right-left" style="width: 10%;padding: 10px;">
                  {{ "form.signCTS" | translate}} &nbsp;
                </div>
                <div class="p-table-base font-color-blue border-top-right-left" style="width: 10%;padding: 10px;">
                  {{ "form.showSign" | translate}} &nbsp;
                </div>
                <div class="p-table-base font-color-blue border-top-right-left" style="width: 20%;padding: 0px;">
                  {{ ""}} &nbsp;
                </div>
              </div>
              <div *ngFor="let user of userSigns; let j = index" class="row" style="margin: 0;">
                <ng-container *ngIf="user.role == '2'">
                  <div class="col-12 row_sign_info" style="height: auto; display: flex; padding: 0px;">
                  <div class="head-table border-top-left" style="width: 20%; padding: 10px; max-width: 80px;">
                    <ng-container *ngIf="selectedServiceType?.internalFlowNotEdit; else isFlowNotEdit">
                      <div class="d-flex justify-content-center">
                        {{user.order}}
                      </div>
                    </ng-container>
                    <ng-template #isFlowNotEdit>
                      <nz-input-number class="td-nz-input" style="width: auto;" [(ngModel)]="user.order" [nzMin]="1"
                      [ngModelOptions]="{ standalone: true }"></nz-input-number>
                    </ng-template>
                  </div>

                  <div class="head-table name-left border-top-left" style="flex: 1;padding: 10px;">
                    <div class="editable-cell" *ngIf="user.userId != null">
                      <div *ngIf="user.departmentName" class="row-icon department"><span
                        class="material-icons">apartment</span>{{ user.departmentName }}</div>
                      <div class="row-icon"><span class="material-icons" *ngIf="!user.departmentName">person</span>
                        {{user.name}} <span *ngIf="user.email">- {{user.email}}</span> <span *ngIf="user.userPosition"> - {{user.userPosition}}</span></div>
                    </div>
                  </div>

                  <!-- <div class="col-3 head-table border-top-left" style="padding: 20px;">
                    <ng-container >
                      <div class="d-flex justify-content-center">
                        <input type="checkbox" class="checkBoxInput" name="signByCTS">
                      </div>
                    </ng-container>
                  </div>
                  <div class="col-2 head-table border-top-left" style="padding: 20px;">
                    <ng-container >
                      <div class="d-flex justify-content-center">
                        <input type="checkbox" class="checkBoxInput" name="displaySign">
                      </div>
                    </ng-container>
                  </div> -->

                  <div class="d-flex align-items-center" style="width: 10%; border-left: 1px solid #d9d9d9;justify-content: center;line-height: 51px; padding-right: 0.75rem !important; border-top: 1px solid #d9d9d9;">
                    <label nz-checkbox [(ngModel)]="user.isSignDigitalCertificate"
                           (ngModelChange)="user.isSignDigitalCertificate ? user.signConfig.showImage = true : user.signConfig.showImage = false; changeCTS(user)"
                           [ngModelOptions]="{ standalone: true }" [nzDisabled]="selectedServiceType?.internalFlowNotEdit"
                    >
                    </label>
                  </div>
                  <div class="d-flex align-items-center" style="width: 10%;border-left: 1px solid #d9d9d9;justify-content: center;line-height: 51px; padding-right: 0.75rem !important; border-top: 1px solid #d9d9d9;">
                    <ng-container *ngIf="user.isSignDigitalCertificate">
                      <label nz-checkbox [ngModel]="user?.signConfig?.showImage"
                             (ngModelChange)="user.signConfig.showImage = $event; changeDisplaySignature(user)"
                             [ngModelOptions]="{ standalone: true }" [nzDisabled]="selectedServiceType?.internalFlowNotEdit">
                      </label>
                    </ng-container>
                  </div>

                  <div class="head-table border-top-right-left" style="width: 20%;padding: 5px;">
                    <ng-container *ngIf="!selectedServiceType?.internalFlowNotEdit">
                      <div class="head-table" style="width: 100%; display: flex; height: 100%; justify-content: space-evenly; align-items: center;">
                        <!-- Nút resize  -->
                        <button color="primary" mat-icon-button (click)="onClickResize(j, user.isCreatedSide)" *ngIf="user?.signConfig?.showImage"
                                type="button">
                          <span *ngIf="user.signConfig.resize">
                            <img src="assets/images/drag_pan.svg"
                                matTooltip="{{ 'enterprise_contract.tooltips.off_change_size_and_position' | translate }}"
                                style="width: 22px; height: 22px;margin-bottom: 3px">
                          </span>
                          <span *ngIf="!user.signConfig.resize">
                            <img src="assets/images/drag_pan-1.svg"
                                matTooltip="{{ 'enterprise_contract.tooltips.on_change_size_and_position' | translate }}"
                                style="width: 22px; height: 22px;margin-bottom: 3px">
                          </span>
                        </button>
                        <!-- Nút thêm chân ký  -->
                        <button (click)="addSign(user)" color="primary" mat-icon-button *ngIf="user?.signConfig?.showImage"
                          type="button">
                          <mat-icon class="mr-0" matTooltip="{{
                            'enterprise_contract.tooltips.add_sign' | translate
                          }}">add_circle
                          </mat-icon>
                        </button>
                        <!-- Nút xóa  -->
                        <a *ngIf="user.userId != null" style="display: flex; align-items: center; width: 30px; justify-content: center;" nz-popconfirm [nzIcon]="iconDel" nzPopconfirmTitle="{{
                            'popup.confirm_delete_user' | translate
                          }}" (nzOnConfirm)="deleteUser(user)"
                          nzCancelText="{{ 'button.cancel' | translate }}" nzOkText="{{ 'button.ok' | translate }}">
                          <i class="fa fa-trash" aria-hidden="true" matTooltip="{{ 'tooltips.delete' | translate }}"></i>
                        </a>
                        <ng-template #iconDel>
                          <i class="text-primary" nz-icon nzType="warning" nzTheme="outline"></i>
                        </ng-template>
                      </div>
                    </ng-container>
                    <ng-container *ngIf="selectedServiceType?.internalFlowNotEdit">
                      <a *ngIf="user.userId != null"
                      >
                        <i class="fa fa-trash disable-delete" aria-hidden="true"></i>
                      </a>
                    </ng-container>
                  </div>
                </div>
                  <!-- Thao tác chân ký  -->
                  <div class="col-12" style="padding: 0px;" *ngFor="let sign of listSign; let id = index">
                    <div class="col-12 row" style="padding: 0px; margin: 0px;" *ngIf="sign.userId == user.userId && checkHaveSign(user, sign)">
                      <div class="head-table border-top-left" style="width: 20%;padding: 10px;">
                      </div>
                      <div class="head-table name-left border-top-left" style=" width: 60%;padding: 10px;">
                        {{ "signature_number" | translate }} {{sign.row_number}} (trang {{sign.pageIndex}})
                      </div>
                      <div class="head-table border-top-right-left" style="width: 20%;padding: 10px; display: flex; justify-content: center;">
                        <button (click)="goToPage(user.enterpriseId || user.enterpriseSignId, user.userId, sign,(user.customerId || null))"
                          color="primary" mat-icon-button type="button">
                          <mat-icon class="mr-0" matTooltip="{{
                            'enterprise_contract.tooltips.go_to_sign' | translate
                          }}">double_arrow
                          </mat-icon>
                        </button>
                        <button (click)="deleteSign(user.enterpriseId || user.enterpriseSignId, user.userId, (sign.contractSignId || sign.idNumber) ,(user.customerId || null))"
                          color="primary" mat-icon-button type="button">
                          <mat-icon class="mr-0" matTooltip="{{
                            'enterprise_contract.tooltips.delete_sign' | translate
                          }}">close
                          </mat-icon>
                        </button>
                      </div>
                    </div>
                  </div>
                </ng-container>
              </div>

              <!-- Tìm kiếm danh sách phê duyệt  -->

              <div class="row" style="margin: 0;">
                <div class="head-table border-top-left" style="width: 20%; max-width: 80px; border-bottom: 1px solid #c9cdd2;">
                </div>
                <div class="head-table border-top-left" style="flex: 1;padding: 0px; border-bottom: 1px solid #c9cdd2;">
                  <div style="width: 100%;">
                    <nz-input-group [nzSuffix]="suffixUserInput" style="padding: 10px">
                      <input [disabled]="warningContractQuantity || selectedServiceType?.internalFlowNotEdit" nz-input [(ngModel)]="inputUserValue"
                             (input)="onChangeUserSignSearch($event)" [nzAutocomplete]="autoUserSearching"
                             [ngModelOptions]="{ standalone: true }"
                             placeholder="{{ 'placeholder.name_email_and_posiotion' | translate }}" #autocompleteInput
                             id="inputUser" />
                      <nz-autocomplete #autoUserSearching>
                        <nz-auto-option *ngFor="let user of filteredUserOptions"
                                        (selectionChange)="autocompleteUserSelected($event, user)" [nzValue]="''">
                          <div *ngIf="user.type === 'DEPARTMENT'" class="row-icon department"><span
                            class="material-icons">apartment</span>{{ user.departmentName }}</div>
                          <div class="row-icon user"
                               *ngIf="(user.type === 'DEPARTMENT' && user.representativeId) || user.type === 'USER'"
                               [class.disabled]="!user.representativeIsActive && user.type === 'DEPARTMENT'">
                            <span class="material-icons" *ngIf="user.type === 'USER'">person</span> {{user.name}} <span *ngIf="user.email">- {{user.email}}</span> <span *ngIf="!user.representativeIsActive && user.type === 'DEPARTMENT'">{{
                              "enterprise_contract.panel_document.table_users.representative_inactive" | translate
                            }}</span> <span *ngIf="user.userPosition"> - {{user.userPosition}}</span>
                          </div>
                          <div class="row-icon disabled user"
                               *ngIf="!user.representativeId && user.type === 'DEPARTMENT'">
                            {{ "enterprise_contract.panel_document.table_users.no_representative_text" | translate }}
                          </div>
                          <hr style="margin: 0; padding: 0" />
                        </nz-auto-option>
                      </nz-autocomplete>
                    </nz-input-group>
                    <ng-template #suffixUserInput>
                      <nz-spin *ngIf="nzCheckLoadingUserSign" nzSimple [nzIndicator]="indicatorUserInput"></nz-spin>
                    </ng-template>
                    <ng-template #indicatorUserInput><i class="nz-icon-font" nz-icon nzType="loading"
                    style="font-size: 24px"></i></ng-template>
                  </div>
                </div>
                <div class="head-table border-top-right-left" style="width: 20%; border-bottom: 1px solid #c9cdd2;">
                </div>
              </div>
              <!--Error inline -->
              <div class="row" style="margin: 0;">
                <mat-error class="font-weight-bold" *ngIf="checkOrderUnique()"
                  style="padding: 0.5rem">
                  {{ "validation.error_order" | translate }}
                </mat-error>
              </div>
              <!-- Danh sách ký duyệt duyệt  -->
              <div class="col-12 p-table-base font-color-blue border-top-right-left" style="padding: 5px;">
                {{ "form.user_signs_and_approves_the_contract" | translate}} &nbsp;
              </div>
              <ng-container *ngFor="let user of userSigns; let j = index">
                <ng-container *ngIf="user.role == '1'" >
                  <div class="row" style="margin: 0;">
                    <div class="head-table border-top-left" style="width: 20%; max-width: 80px;padding: 10px;">
                        <div class="d-flex justify-content-center" style="display: flex; justify-content: center; align-items: center;">
                          1
                        </div>
                    </div>
                    <div class="head-table name-left border-top-left" style="word-break: break-all; padding: 10px; flex: 1">
                      <div class="editable-cell" *ngIf="user.userId != null">
                        <div *ngIf="user.departmentName" class="row-icon department"><span
                          class="material-icons">apartment</span>{{ user.departmentName }}</div>
                        <div class="row-icon"><span class="material-icons" *ngIf="!user.departmentName">person</span>
                          {{user.name}} <span *ngIf="user.email">- {{user.email}}</span> <span *ngIf="user.userPosition"> - {{user.userPosition}}</span></div>
                      </div>
                    </div>
                    <div class="head-table border-top-right-left" style="width: 20%;padding: 5px;">
                      <div class="head-table" style="width: 100%; display: flex; height: 100%; justify-content: space-evenly; align-items: center;">
                        <!-- Nút resize  -->
                        <button color="primary" mat-icon-button (click)="onClickResize(j, user.isCreatedSide)" *ngIf="user?.signConfig?.showImage"
                                type="button">
                          <span *ngIf="user.signConfig.resize">
                            <img src="assets/images/drag_pan.svg"
                                matTooltip="{{ 'enterprise_contract.tooltips.off_change_size_and_position' | translate }}"
                                style="width: 22px; height: 22px;margin-bottom: 3px">
                          </span>
                          <span *ngIf="!user.signConfig.resize">
                            <img src="assets/images/drag_pan-1.svg"
                                matTooltip="{{ 'enterprise_contract.tooltips.on_change_size_and_position' | translate }}"
                                style="width: 22px; height: 22px;margin-bottom: 3px">
                          </span>
                        </button>
                        <!-- Nút thêm chân ký  -->
                        <button (click)="addSign(user)" color="primary" mat-icon-button *ngIf="user?.signConfig?.showImage"
                          type="button">
                          <mat-icon class="mr-0" matTooltip="{{
                            'enterprise_contract.tooltips.add_sign' | translate
                          }}">add_circle
                          </mat-icon>
                        </button>
                        <!-- Nút xóa  -->
                        <ng-container *ngIf="!selectedServiceType?.internalFlowNotEdit">
                          <a *ngIf="user.userId != null" style="display: flex; align-items: center; width: 30px;height: 30px; justify-content: center;" nz-popconfirm [nzIcon]="iconDel" nzPopconfirmTitle="{{
                              'popup.confirm_delete_party' | translate
                            }}" (nzOnConfirm)="deleteUser(user)"
                            nzCancelText="{{ 'button.cancel' | translate }}" nzOkText="{{ 'button.ok' | translate }}" class="delete-icon">
                            <i class="fa fa-trash" aria-hidden="true" matTooltip="{{ 'tooltips.delete' | translate }}"></i>
                          </a>
                          <ng-template #iconDel>
                            <i class="text-primary" nz-icon nzType="warning" nzTheme="outline"></i>
                          </ng-template>
                        </ng-container>
                        <ng-container *ngIf="selectedServiceType?.internalFlowNotEdit">
                          <a *ngIf="user.userId != null" class="delete-icon"
                          >
                            <i class="fa fa-trash disable-delete" aria-hidden="true"></i>
                          </a>
                        </ng-container>
                      </div>
                    </div>
                  </div>
                  <!-- Danh sách chân ký  -->
                  <div *ngFor="let sign of listSign; let id = index">
                    <div class="row" style="margin: 0;" *ngIf="sign.userId == user.userId && checkHaveSign(user, sign)">
                      <div class="head-table border-top-left" style="padding: 0px; width: 20%; max-width: 80px;">
                      </div>
                      <div class="head-table name-left border-top-left" style="padding: 5px; flex: 1;">
                        {{ "signature_number" | translate }} {{sign.row_number}} (trang {{sign.pageIndex}})
                      </div>
                      <div class="head-table border-top-right-left" style="padding: 5px; display: flex; justify-content: center; width: 20%;">
                        <button (click)="goToPage(user.enterpriseId || user.enterpriseSignId, user.userId, sign,(user.customerId || null))"
                          color="primary" mat-icon-button type="button">
                          <mat-icon class="mr-0" matTooltip="{{
                            'enterprise_contract.tooltips.go_to_sign' | translate
                          }}">double_arrow
                          </mat-icon>
                        </button>
                        <button (click)="deleteSign(user.enterpriseId || user.enterpriseSignId, user.userId, (sign.contractSignId || sign.idNumber) ,(user.customerId || null))"
                          color="primary" mat-icon-button type="button">
                          <mat-icon class="mr-0" matTooltip="{{
                            'enterprise_contract.tooltips.delete_sign' | translate
                          }}">close
                          </mat-icon>
                        </button>
                      </div>
                    </div>
                  </div>
                </ng-container>
              </ng-container>
              <!-- Tìm kiếm danh sách ký duyệt  -->
              <div *ngIf="!hasRoleOneSelected()" class="row" style="margin: 0; border-bottom: 1px solid #d9d9d9;" >
                <div class="head-table border-top-left" style="width: 20%;padding: 0px; max-width: 80px;">
                </div>
                <div class="head-table border-top-left" style="flex: 1;padding: 0px;">
                  <div style="width: 100%;">
                    <nz-input-group [nzSuffix]="suffixUserInput" style="padding: 10px">
                      <input [disabled]="warningContractQuantity || selectedServiceType?.internalFlowNotEdit" nz-input [(ngModel)]="inputUserSignValue"
                             (input)="onChangeUserSign($event)" [nzAutocomplete]="autoUserSignSearching"
                             [ngModelOptions]="{ standalone: true }"
                             placeholder="{{ 'placeholder.name_email_and_posiotion' | translate }}" #autocompleteInput
                             id="inputUserSign" />
                      <nz-autocomplete #autoUserSignSearching>
                        <nz-auto-option *ngFor="let user of filteredUserSign"
                                        (selectionChange)="autocompleteUserSignSelected($event, user)" [nzValue]="''">
                          <div *ngIf="user.type === 'DEPARTMENT'" class="row-icon department"><span
                            class="material-icons">apartment</span>{{ user.departmentName }}</div>
                          <div class="row-icon user"
                               *ngIf="(user.type === 'DEPARTMENT' && user.representativeId) || user.type === 'USER'"
                               [class.disabled]="!user.representativeIsActive && user.type === 'DEPARTMENT'">
                            <span class="material-icons" *ngIf="user.type === 'USER'">person</span> {{user.name}} <span *ngIf="user.email">- {{user.email}}</span> <span *ngIf="!user.representativeIsActive && user.type === 'DEPARTMENT'">{{
                              "enterprise_contract.panel_document.table_users.representative_inactive" | translate
                            }}</span>
                            <!-- <span *ngIf="user.userPosition"> - {{user.userPosition}}</span> -->
                          </div>
                          <div class="row-icon disabled user"
                               *ngIf="!user.representativeId && user.type === 'DEPARTMENT'">
                            {{ "enterprise_contract.panel_document.table_users.no_representative_text" | translate }}
                          </div>
                          <hr style="margin: 0; padding: 0" />
                        </nz-auto-option>
                      </nz-autocomplete>
                    </nz-input-group>
                    <ng-template #suffixUserInput>
                      <nz-spin *ngIf="nzCheckLoadingUser" nzSimple [nzIndicator]="indicatorUserInput2"></nz-spin>
                    </ng-template>
                    <ng-template #indicatorUserInput2><i class="nz-icon-font" nz-icon nzType="loading"
                    style="font-size: 24px"></i></ng-template>
                  </div>
                </div>
                <div class="head-table border-top-right-left" style="width: 20%;padding: 0px;">
                </div>
              </div>
              <mat-error class="font-weight-bold  border-top-right-left error-message-signer" *ngIf="isNoSigner">
                {{ "validation.error_user_no_set_up" | translate }}
              </mat-error>
              </div>
            </div>
          </div>

          <!-- Thêm bên lập -->
          <!-- <div class="row p-table-base border-top-right-left font-color-blue" style="font-weight: 600; align-items: center;" *ngIf="!enterpriseSign.length">
            {{ "form.add_create_sign" | translate }}
            <mat-icon class="ml-0 text-primary" style="font-size: x-large; cursor: pointer; margin-left: 8px !important;"
                      matTooltip="{{ 'form.add_create_sign' | translate }}" (click)="addEnterprise(true)">
              add_circle_outline
            </mat-icon>
          </div> -->

        


        <!-- Các bên ký kết hợp đồng/văn bản  -->
        <mat-expansion-panel class="mat-elevation-z mt-3"
                             expanded="true"
                             #mePanel="matExpansionPanel" *ngIf="(mode === 'view')"
        >
          <mat-expansion-panel-header>
            <!-- Thông tin liên hệ -->
            <mat-panel-title class="mat-panel-title justify-content-between">
              <span>{{ 'form.sign_contract' | translate }}</span>
            </mat-panel-title>
          </mat-expansion-panel-header>

          <!-- View contract -->
          <div  class="mt-3">
            <app-contract-sign-status
              [contractSignStatus]="contractSignStatus"
              [contractStatus]="contractStatus">
            </app-contract-sign-status>
          </div>
        </mat-expansion-panel>

        <!-- Hợp đồng/văn bản liên kết  -->
        <mat-expansion-panel class="mat-elevation-z mt-3" *ngIf="(mode === 'view' && dataDocumentParent && dataDocumentParent.length > 0) || mode !== 'view'"
                             expanded="true"
                             #mePanel="matExpansionPanel"
        >
          <mat-expansion-panel-header>
            <!-- Thông tin liên hệ -->
            <mat-panel-title class="mat-panel-title justify-content-between">
              <span>{{ 'form.digital_contract.document_parent' | translate }}</span>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div *ngIf="mode !== 'view'">
            <form [formGroup]="mainFormAdd" class="py-3">
              <!--  Hợp đồng cha-->
              <div class="w-100 ">
                <form nz-frm>
                  <nz-table #editRowInternalTable nzBordered [nzData]="dataDocumentParent" [nzShowPagination]="false" [nzNoResult]="contentEmptyTable1"
                            [nzFrontPagination]="false" class="ant-table-no-placeholder-border-bottom">
                    <thead>
                    <tr>
                      <th class="text-center" nzWidth="25px">
                        {{
                          "enterprise_contract.panel_document.table_users.header.order"
                            | translate
                        }}
                      </th>
                      <th class="text-center" nzWidth="60%">
                        {{
                          "form.digital_contract.document_information"
                            | translate
                        }}
                      </th>
                      <th class="text-center" nzWidth="100px">{{ 'search_form.status' | translate}}</th>
                      <th class="text-center">
                        <!--                        {{-->
                        <!--                          "enterprise_contract.panel_document.table_users.header.action"-->
                        <!--                            | translate-->
                        <!--                        }}-->
                      </th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr *ngFor="let data of editRowInternalTable.data; let i = index" class="editable-row">
                      <!-- TT -->
                      <td class="text-center">{{ i + 1 }}</td>
                      <!-- Tên -->
                      <td class="word-break-line">
                        <div class="editable-cell">
                          <div class="row-icon"> {{ data.code }}
                            - {{ data.name }}
                          </div>
                        </div>
                      </td>
                      <td class="text-center">
                        <span *ngIf="data.status == 1">{{ 'search_form.draft' | translate}}</span>
                        <span *ngIf="data.status == 2">{{ 'search_form.processing' | translate}}</span>
                        <span *ngIf="data.status == 3">{{ 'search_form.denied_sign' | translate}}</span>
                        <span *ngIf="data.status == 4 && data.contractTerminationStatus != 2 && data.contractTerminationStatus != 4">{{ 'search_form.finish' | translate}}</span>
                        <span *ngIf="data.status == 5">{{ 'search_form.cancelled' | translate}}</span>
                        <span *ngIf="data.status == 6">{{ 'search_form.wait_confirm_enterprice_no_moit' | translate}}</span>
                        <span *ngIf="data.status == 7">{{ 'contract_share_partner.issued' | translate}}</span>
                        <span *ngIf="data.status == 8">{{ 'contract_share_partner.issued' | translate}}</span>
                        <span *ngIf="data.status == 9">{{ 'search_form.wait_confirm_enterprice_no_moit' | translate}}</span>
                        <span *ngIf="data.status == 4 && data.contractTerminationStatus == 2">{{ 'contract_terminate.terminating' | translate}}</span>
                        <span *ngIf="data.status == 4 && data.contractTerminationStatus == 4">{{ 'contract_terminate.terminated' | translate}}</span>
                      </td>
                      <!-- Action -->
                      <td class="td-nz-icon text-center">
                        <button mat-icon-button (click)="viewContract(data)" *ngIf="data.id && mode !== 'view'" aria-label="View" style="color: #07736C">
                          <mat-icon>
                            visibility
                          </mat-icon>
                        </button>
                        <button (click)="onClickDeleteElementRecordInternalUser(data.id)"
                                *ngIf="data.id && mode !== 'view'" aria-label="Clear"
                                mat-button mat-icon-button matSuffix style="color: #ee0033"
                                type="button">
                          <i class="fa fa-trash" aria-hidden="true" matTooltip="{{ 'tooltips.delete' | translate }}"></i>
                        </button>
                      </td>
                    </tr>
                    <tr class="editable-row">
                      <!-- TT -->
                      <td class="text-center">&nbsp;</td>
                      <!-- Tên -->
                      <td colspan="3">
                        <div>
                          <nz-input-group [nzSuffix]="suffixPartyInput">
                            <input nz-input [(ngModel)]="inputInternalDocumentsValue" (input)="getParentContractNew($event)"
                                   [nzAutocomplete]="autoInternalUserSearching" [ngModelOptions]="{ standalone: true }" placeholder="{{
                        'placeholder.document_parent' | translate
                      }}" #autocompleteInput id="inputUser1" />
<!--                            <input  nz-input [(ngModel)]="inputInternalDocumentsValue"-->
<!--                                    (keyup)="getParentContractNew($event)"-->
<!--                                    [nzAutocomplete]="autoInternalUserSearching"-->
<!--                                    [ngModelOptions]="{ standalone: true }"-->
<!--                                    placeholder="{{ 'placeholder.document_parent' | translate }}"-->
<!--                                    #autocompleteInput id="inputUser1"/>-->
                            <nz-autocomplete #autoInternalUserSearching>
                              <nz-auto-option *ngFor="let user of parentContracts"
                                              (selectionChange)="autocompleteInternalUserSelected($event, user)"
                                              [nzValue]="''">
                                <div class="d-flex">
                                  <span style="line-height: 20px">
                                      {{ user.code }} - {{ user.name }}
                                    </span>
                                </div>
                              </nz-auto-option>
                            </nz-autocomplete>
                          </nz-input-group>
                          <ng-template #suffixPartyInput>
                            <nz-spin *ngIf="nzCheckLoadingParty1" nzSimple [nzIndicator]="indicatorPartyInput"></nz-spin>
                          </ng-template>
                          <ng-template #indicatorPartyInput><i class="nz-icon-font" nz-icon nzType="loading"
                                                               style="font-size: 24px"></i>
                          </ng-template>
                        </div>
                      </td>
                      <!-- Thực hiện -->
                      <!--                      <td class="td-nz-icon text-center">&nbsp;</td>-->
                    </tr>
                    </tbody>
                  </nz-table>
                  <ng-template #contentEmptyTable1 ></ng-template>
                </form>
              </div>
            </form>
          </div>

          <!-- View contract -->
          <div *ngIf="mode === 'view' && dataDocumentParent && dataDocumentParent.length > 0" class="mt-3">
            <nz-table #editRowInternalTable nzBordered [nzData]="dataDocumentParent" [nzShowPagination]="false" [nzNoResult]="contentEmptyTable"
                      [nzFrontPagination]="false" class="ant-table-no-placeholder-border-bottom">
              <thead>
              <tr>
                <th class="text-center" nzWidth="25px">
                  {{
                    "enterprise_contract.panel_document.table_users.header.order"
                      | translate
                  }}
                </th>
                <th class="text-center" nzWidth="80%">
                  {{
                    "form.digital_contract.document_information"
                      | translate
                  }}
                </th>
                <th class="text-center" nzWidth="100px">{{ 'search_form.status' | translate}}</th>
                <th class="text-center">
                  <!--                        {{-->
                  <!--                          "enterprise_contract.panel_document.table_users.header.action"-->
                  <!--                            | translate-->
                  <!--                        }}-->
                </th>
              </tr>
              </thead>
              <tbody>
              <tr *ngFor="let data of editRowInternalTable.data; let i = index" class="editable-row">
                <!-- TT -->
                <td class="text-center">{{ i + 1 }}</td>
                <!-- Tên -->
                <td class="word-break-line">
                  <div class="editable-cell">
                    <div class="row-icon"> {{ data.code }}
                      - {{ data.name }}
                    </div>
                  </div>
                </td>
                <td class="text-center">
                  <span *ngIf="data.status == 1">{{ 'search_form.draft' | translate}}</span>
                  <span *ngIf="data.status == 2">{{ 'search_form.processing' | translate}}</span>
                  <span *ngIf="data.status == 3">{{ 'search_form.denied_sign' | translate}}</span>
                  <span *ngIf="data.status == 4 && data.contractTerminationStatus != 2 && data.contractTerminationStatus != 4">{{ 'search_form.finish' | translate}}</span>
                  <span *ngIf="data.status == 5">{{ 'search_form.cancelled' | translate}}</span>
                  <span *ngIf="data.status == 6">{{ 'search_form.wait_confirm_enterprice_no_moit' | translate}}</span>
                  <span *ngIf="data.status == 7">{{ 'contract_share_partner.issued' | translate}}</span>
                  <span *ngIf="data.status == 8">{{ 'contract_share_partner.issued' | translate}}</span>
                  <span *ngIf="data.status == 9">{{ 'search_form.wait_confirm_enterprice_no_moit' | translate}}</span>
                  <span *ngIf="data.status == 4 && data.contractTerminationStatus == 2">{{ 'contract_terminate.terminating' | translate}}</span>
                  <span *ngIf="data.status == 4 && data.contractTerminationStatus == 4">{{ 'contract_terminate.terminated' | translate}}</span>
                </td>
                <!-- Action -->
                <td class="td-nz-icon text-center">
                  <button mat-icon-button (click)="viewContract(data)" *ngIf="data.id " aria-label="View" style="color: #07736C">
                    <mat-icon>
                      visibility
                    </mat-icon>
                  </button>
                </td>
              </tr>
              </tbody>
            </nz-table>
            <ng-template #contentEmptyTable ></ng-template>
          </div>
        </mat-expansion-panel>


        <!-- Danh sách đính kèm  -->
        <mat-expansion-panel expanded="true" class="mat-elevation-z mt-3" *ngIf="(mode === 'view' && filesAttachment && filesAttachment.length > 0) || mode !== 'view'">
          <mat-expansion-panel-header>
            <mat-panel-title class="mat-panel-title justify-content-between">
              {{'form.attach_file_list' | translate}}
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div *ngIf="mode !== 'view'">
            <app-upload-multi-file-attachments [isAttachFileForDocument]="true"
                                   [arrAttachments]="filesAttachment"
                                   [filesAttachmentOld]="filesAttachmentOld"
                                   [typeCreateContract]="1"
                                   [isEdit]="contractId"
                                   [maxSize]="maxSize"
                                   (fileAttachmentEmit)="changeFileAttachment($event)"
                                   (deleteFileEmit)="deleteFileAttachment($event)"
                                   [maxPerAttachFile]="maxPerAttachFile"
                                   [maxSizeSystem]="maxSizeSystem"
                                   [mainFiles]="mainFiles"
                                   >
            </app-upload-multi-file-attachments>
            <mat-hint class="hint-text d-flex justify-content-center">
              {{'hint.attach_accept_pdf_image_email' | translate}}
            </mat-hint>
          </div>
          <div *ngIf="mode === 'view'">
            <div class="mt-2 fix-width d-flex" *ngFor="let item of filesAttachment">
              <a (click)="downloadFile(item.id, item.fileName)" style="width: 90%;" class="text-truncate">
                <em class="fa fa-download fa-fw text-primary" matTooltip="{{ 'tooltips.download' | translate }}"></em>
                <span [matTooltip]="item.fileName"> {{ item.fileName }}</span>
              </a>
            </div>
          </div>
        </mat-expansion-panel>
      </div>

      <!--      pdf-->
      <div class="view-digital-contract {{isViewFull ? 'w-100' : 'col-7'}} {{pdfSrc ? 'd-block' : 'd-flex'}}">
        <!-- [ngStyle]="{'background': !pdfSrc ? '#D6D6D6' : '#fff'}" -->
        <div [hidden]="pdfSrc || mode === 'view'" class="chooseFiles">
          <h3 style="color: #005e5b">
            {{ "enterprise_contract.panel_document.lb_create_document" | translate }}
          </h3>
          <br/>
          <button #btnUpload (click)="inputUpload.click()" [ngClass]="{ active_document: false }" class="mr-2 mat-stroked-button-create-document"
                  color="primary" id="btnUpload" appTrackEvent="w.btn.hdsohoatoiquanly.them.chontumay"
                  mat-stroked-button type="button">
            <mat-icon class="mr-0">cloud_upload</mat-icon>
            {{ "button.choose_a_file" | translate }}
          </button>
          <input #inputUpload (change)="onSelectedUpload($event)" accept=".pdf"
                 class="form-control-file vt-input-form d-none " id="file"
                 multiple name="file" type="file"/>
          <h5 *ngIf="mode !== 'view'" style="margin-top: 2em; font-weight: bold; text-align: center;">
            ({{ mesage }})
          </h5>
          <br/><br/>
        </div>
        <div *ngIf="pdfSrc" class="pdf-header mat-elevation-z0 border-bottom">
          <div class="d-flex justify-content-between">
            <div class="py-2 px-3 bg-white d-flex desktop" id="box-left">
              <button (click)="isViewFull = !isViewFull" class="mr-2 ml-2 btn-toggle-view-full" color="primary" mat-icon-button
                    [matTooltip]="(isViewFull ? 'enterprise_contract.tooltips.btn_expand_less' : 'enterprise_contract.tooltips.btn_expand_more') | translate"
                      type="button">
                <mat-icon [hidden]="isViewFull" class="fullview-icon" matTooltip="{{
                  'enterprise_contract.tooltips.btn_expand_more' | translate
                  }}">
                  arrow_back_ios
                </mat-icon>
                <mat-icon [hidden]="!isViewFull" class="fullview-icon" matTooltip="{{
                    'enterprise_contract.tooltips.btn_expand_less' | translate
                  }}">
                  arrow_forward_ios
                </mat-icon>
              </button>
            </div>

            <div class="d-flex" id="box-center">
              <div class="pdf-tab-wrapper">
                <div class="d-flex box-tab" cdkDropList cdkDropListOrientation="horizontal"
                     (cdkDropListDropped)="drop($event)">
                  <div (click)="changeFile(i)" *ngFor="let file of filesName; let i = index" cdkDrag
                       [cdkDragDisabled]="mode === 'view' ? true : false"
                       [class.active]="i === activeFile"
                       [class.border-right]="i !== filesName.length - 1 && i !== activeFile && i !== activeFile - 1"
                       [class.left]="i === activeFile - 1"
                       [class.right]="i === activeFile + 1"
                       [matTooltip]="file.name" class="pl-2 py-2 tab d-flex">
                    <div [title]="file" class="name">
                      {{ file }}
                    </div>
                    <a (click)="removeFile(i)"><span *ngIf="mode !== 'view'" class="material-icons"> close </span></a>
                  </div>
                </div>
              </div>
            </div>

            <div class="px-3 py-2 bg-white pdf-actions" id="box-right">
              <div *ngIf="mode !== 'view'">
                <button #btnUpload (click)="inputUpload.click()" [ngClass]="{ active_document: true }" class="ml-2 mat-stroked-button-create-document"
                        color="primary" id="btnUpload" mat-stroked-button appTrackEvent="w.btn.hdsohoatoiquanly.them.chontumay"
                        type="button"
                        [matTooltip]="'button.choose_a_file' | translate"
                >
                  <mat-icon class="mr-0">cloud_upload</mat-icon>
                </button>
                <input #inputUpload (change)="onSelectedUpload($event)"
                       accept=".pdf"
                       class="form-control-file vt-input-form d-none " id="file"
                       multiple
                       name="file" type="file"/>
              </div>
              <ng-container *ngIf="mode === 'view'">
                <button (click)="doPrint()" mat-stroked-button class="mr-2 btn-download-file-sm desktop" color="primary">
                  <mat-icon class="mr-0">print</mat-icon>
                  {{ "enterprise_contract.buttons.print" | translate }}
                </button>

                <button (click)="downloadContract()" class="btn-download-file-sm desktop" color="primary" mat-stroked-button
                        [matTooltip]="'tooltips.download' | translate">
                  <mat-icon class="mr-0">save_alt</mat-icon>
                  {{ 'button.download' | translate }}
                </button>
              </ng-container>
            </div>
          </div>
        </div>
        <div *ngIf="pdfSrc === 'notPDF'" class="mt-5 d-flex justify-content-center px-5">
          <h5>
            {{ "digital_contract.error.fileNotSupportPreview" | translate }}
            <span *ngIf="mode === 'view'">{{ "digital_contract.error.download_please" | translate }}</span>
          </h5>
        </div>
        <ng-container *ngIf="pdfSrc && pdfSrc !== 'notPDF'">
          <ng-container *ngIf="pdfSrc !== 'notPDF' && !isViewParentContract">
            <!-- <ngx-extended-pdf-viewer [enablePrint]="true"
                                     [language]="language" [showPrintButton]="false"
                                     [showBookmarkButton]="false" [showDownloadButton]="false"
                                     [showOpenFileButton]="false"
                                     [showPropertiesButton]="false" [showRotateButton]="false"
                                     [showSecondaryToolbarButton]="false"
                                     [showUnverifiedSignatures]="true" [sidebarVisible]="true" [src]="pdfSrc"
                                     [textLayer]="true"
                                     [theme]="'dark'"
                                     [zoom]="isViewFull ? 'page-width' : '100'"
                                     class="pdf-viewer" style="display: block; width: 100%; height: calc(100% - 52px)"
                                     useBrowserLocale="true"
                                     (pdfLoaded)="onPdfLoaded()"
                                     [showHandToolButton]="false"
                                     (textLayerRendered)="textLayerRendered($event)"
                                     [httpHeaders]="authorization">
            </ngx-extended-pdf-viewer> -->

            <ngx-extended-pdf-viewer (currentZoomFactor)="onChangeZoom($event)"
            (textLayerRendered)="textLayerRendered($event)" [(page)]="pageIndex" [enablePrint]="true"
            [handTool]="false" [language]="language" [showBookmarkButton]="false" [showDownloadButton]="false"
            [showOpenFileButton]="false" [showPropertiesButton]="false" [showRotateButton]="false"
            [showSecondaryToolbarButton]="false" [showUnverifiedSignatures]="true" [sidebarVisible]="true"
            [src]="pdfSrc" [textLayer]="true" [theme]="'dark'" [zoomLevels]="[0.5, 1, 1.25, 1.5, 2, 3, 4]"
            class="pdf-viewer" style="display: block; width: 100%; height: calc(100% - 52px)" useBrowserLocale="true"
            (pdfLoaded)="onPdfLoaded()" [(zoom)]="zoomLevel"
            (pageRendered)="onPageRendered($event)"
            [httpHeaders]="authorization">
            </ngx-extended-pdf-viewer>
          </ng-container>
        </ng-container>
      </div>
    </mat-accordion>

  </mat-card-content>
  <div style="background-color: white"
       class="scontract-btn-dsk scontract-btn-deskbg-white boder-create-contract text-center mat-elevation-z0 py-2 w-100">
    <button *ngIf="mode !== 'view'" appTrackEvent="w.btn.hdsohoatoiquanly.them.huy_bo"
            (click)="cancelAdd()"
            class="mr-3"
            color="primary"
            id="btn-cancel"
            mat-stroked-button
            type="button">
      <mat-icon class="mr-0">cancel</mat-icon>
      {{ "button.cancel" | translate }}
    </button>
    <button *ngIf="mode === 'view'"
            (click)="cancelAdd()"
            class="mr-3" color="primary"
            mat-stroked-button
            type="button">
      <mat-icon class="mr-0">arrow_back</mat-icon>
      {{ "button.back" | translate }}
    </button>
    <button *ngIf="mode !== 'view' && showInfo == true"
            (click)="backTab()"
            class="mr-3" color="primary"
            mat-stroked-button
            type="button">
      <mat-icon class="mr-0">arrow_back</mat-icon>
      {{ "button.back" | translate }}
    </button>
    <button mat-stroked-button color="primary" class="btn mr-3" (click)="openDialogCancelSignFlow()" appTrackEvent="w.btn.xem_chi_tiet_hd.huy_luong_ky"
              *ngIf="isCancelDocument">
        <mat-icon class="mr-0">cancel</mat-icon>
        {{ "enterprise_contract.buttons.cancel_flow" | translate }}
      </button>
      <button mat-stroked-button color="primary" class="btn mr-3" (click)="openDialogRefuseSignDocument()"  appTrackEvent="w.btn.xem_chi_tiet_hd.tu_choi_ky_duyet"
          *ngIf="isSignDocument">
            <mat-icon class="mr-0">cancel</mat-icon>
          {{ "enterprise_contract.buttons.reject" | translate }}
        </button>
    <button mat-stroked-button color="primary" class="btn mr-3" (click)="openDialogRefuseApprovalDocument()" appTrackEvent="w.btn.xem_chi_tiet_hd.tu_choi_phe_duyet"
      *ngIf="isApproveDocument">
        <mat-icon class="mr-0">cancel</mat-icon>
          {{ "enterprise_contract.buttons.reject" | translate }}
    </button> 
    <button (click)="goToSign()" *ngIf="mode === 'view' && contractStatus == 2 && isSignDocument" class="mr-3" color="primary"
            mat-raised-button
            type="button">
      <mat-icon class="mr-0">gesture</mat-icon>
        {{ "enterprise_contract.buttons.sign" | translate }}
    </button>
    <button mat-raised-button color="primary" class="btn mr-3" (click)="openDialogApprovalDocument()" appTrackEvent="w.btn.xem_chi_tiet_hd.duyet"
              *ngIf="isApproveDocument">
        <mat-icon class="mr-0">edit</mat-icon>
        {{ "enterprise_contract.buttons.approve" | translate }}
      </button>
    <!-- <button (click)="nexttab()" *ngIf="(mode === 'view' && contractStatus == 1) && showInfo == false" class="mr-3" color="primary"
            mat-raised-button
            type="button">
            {{ "button.next" | translate }}
            <mat-icon class="mr-0">arrow_forward</mat-icon>
    </button> -->
    <button (click)="nexttab()" *ngIf="mode !== 'view' && showInfo == false" class="mr-3" color="primary"
          [disabled]="checkOrderUnique()"
          mat-raised-button
          type="button">
          {{ "button.next" | translate }}
          <mat-icon class="mr-0">arrow_forward</mat-icon>
    </button>
    <button (click)="saveContract()" *ngIf="mode !== 'view' && showInfo == true" class="mr-3" color="primary" mat-raised-button appTrackEvent="w.btn.hdsohoatoiquanly.them.lap_hd"
            type="button">
      <mat-icon class="mr-0">save</mat-icon>
      {{ (mode === 'create' ? "button.creare_doc" : "button.save") | translate }}
    </button>
    <!-- <button (click)="saveContract(true)" *ngIf="mode !== 'view' && showInfo == true" class="mr-3" color="primary"
            mat-raised-button
            type="button">
      <mat-icon class="mr-0">gesture</mat-icon>
        {{ "enterprise_contract.buttons.sign" | translate }}
    </button> -->

    <button mat-raised-button color="primary" *ngIf="mode !== 'view' && showInfo == true" class="btn mr-3"
              (click)="onClickBtnSignFlow()" appTrackEvent="w.btn.lap_hd.thuc_hien_luong_ky">
              <mat-icon class="mr-0">send</mat-icon>
              {{ "enterprise_contract.buttons.start_flow" | translate }}
            </button>
    
    <button mat-raised-button color="primary" *ngIf="mode === 'view' && showInfo == false && contractStatus == 1" class="btn mr-3"
              (click)="signFlowDetail()" appTrackEvent="w.btn.lap_hd.thuc_hien_luong_ky">
              <mat-icon class="mr-0">send</mat-icon>
              {{ "enterprise_contract.buttons.start_flow" | translate }}
            </button>

    <button (click)="moveToUpdate()" *ngIf="mode === 'view' && !statusBackup && contractStatus == 1" class="mr-3" color="primary"
            mat-raised-button
            type="button">
      <!--        <mat-icon class="mr-0">save</mat-icon>-->
      {{ (mode === 'view' ? "button.update" : "button.creare_doc") | translate }}
    </button>
    <button mat-raised-button *ngIf="mode === 'view'" (click)="openViewProperties()" class="btn" color="primary">
      {{ "add_document_moha.labor_contract_report_information" | translate }}
    </button>

  </div>
</mat-card>
